export default "__VITE_PUBLIC_ASSET__ba7c02e9__"